import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import { FlightTakeoff } from "@material-ui/icons";
import { getSecureRandom } from "../../Helper/random";

const PrettoSlider = withStyles({
  root: {
    position: "absolute",
    width: "100%",
    marginTop: 50,
  },
  thumb: {
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "flex-start",
    marginTop: -26,
    marginLeft: -30,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  track: {
    height: 5,
    borderRadius: 5,
  },
  rail: {
    height: 5,
    borderRadius: 5,
  },
})(Slider);

function AirbnbThumbComponent(props) {
  return (
    <span {...props}>
      <FlightTakeoff fontSize="large" />
    </span>
  );
}

export default function CustomizedSlider(props) {
  const [value, setValue] = React.useState(10);
  React.useEffect(() => {
    const intervalId = setInterval(
      () =>
        setValue(value => {
          return value + getSecureRandom() * 20 >= 100 && props.loading
            ? value * getSecureRandom() * 0.15 + 5
            : value + getSecureRandom() * (value * 0.01);
        }),
      8
    );

    return () => clearInterval(intervalId);
  }, [value]);

  return props.loading ? <PrettoSlider ThumbComponent={AirbnbThumbComponent} value={value} /> : <></>;
}
